import React from 'react';

const Header = () => (
  <header>
    <h2>
      <a href="/">Collatz Music</a>
    </h2>
    <hr />
  </header>
);

export default Header;
